import React, {useState, useEffect} from 'react'

import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
// USE THE IMPORT BELOW INSTEAD IF YOU ARE USING THE PRO VERSION
// import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox-pro'
import lightBoxOptions from '../data/LightBoxOptions';

import WorkItemPD2021 from './WorkItemPD2021'
import WorkItemID2021 from './WorkItemID2021'

import WorksPD2021 from '../data/WorksPD2021'
import WorksID2021 from '../data/WorksID2021'


function Works() {

    const [PD2021Lists, setPD2021Lists] = useState([])
    const [ID2021Lists, setID2021Lists] = useState([])

    useEffect(() => {setPD2021Lists(WorksPD2021)}, []);
    useEffect(() => {setID2021Lists(WorksID2021)}, []);

    const displayPD2021 = PD2021Lists.map((item, i) => <WorkItemPD2021 key={i} id={item.id} name={item.name} category={item.category} author={item.author} image={item.image}/>)

    const displayID2021 = ID2021Lists.map((item, i) => <WorkItemID2021 key={i} id={item.id} name={item.name} category={item.category} author={item.author} image={item.image}/>)




    return(
        <section id="portfolioSection" className="section">
            <div className="container-fluid-small">
                
                <div id="productDesign2021" className="exercise-box">
                    <h3 className="anim-bot">■プロダクトデザイン演習I【1回生作品】</h3>
                    <p className="anim-bot desc">
                        テーマ：ニッポン文化のブランディング<br />
                        国内外の人々が抱く「ニッポン」のイメージを分析し、市場調査、トレンドセッティング、ブランド構築（ロゴ、パッケージ、販促ツール制作）、プロダクトデザインの設計、制作などのプロセスを通し、情報デザイン及びプロダクトデザインにおいて必要不可欠な基礎知識・基礎スキル習得を目的とする。
                    </p>

                    <div className="row portfolio-row">
                        {displayPD2021}
                    </div>
                </div>

                <div id="interiorDesign2021" className="exercise-box">
                    <h3 className="anim-bot">■インテリアデザイン演習【3回生作品】</h3>
                    <p className="anim-bot desc">
                    この授業は、株式会社スペースとの産学連携としてインテリア系専攻の３回生が課題に取り組みました。テーマは「スーパーマーケットの日常」。スペースで活躍されるプロデューサーやデザイナーの方々によって企画され、実践さながらのコンセプトワークからデザインまでを監修、ご指導頂きました。この貴重な体験は空間デザインを学ぶ学生にとって大変有意義な時間となりました。
                    </p>
                    <div className="row portfolio-row">
                        {displayID2021}
                    </div>

                    <SimpleReactLightbox>
                        <SRLWrapper options={lightBoxOptions}>
                            <div className="row portfolio-row">
                                <div className={`col-12 col-sm-12 col-md-12 col-lg-15 col-xl-15 portfolio-box anim-bot`} >                            
                                    <div className="portfolio-image">
                                    <a href="/oitid/student/assets/images/project/2021/id_exercise/scene_01.jpg">
                                        <div className="dark-bg"></div>
                                        <img src="/oitid/student/assets/images/project/2021/id_exercise/scene_01.jpg" alt="" />
                                    </a>
                                    </div>
                                </div>
                                <div className={`col-12 col-sm-12 col-md-12 col-lg-15 col-xl-15 portfolio-box anim-bot`} >                            
                                    <div className="portfolio-image">
                                    <a href="/oitid/student/assets/images/project/2021/id_exercise/scene_02.jpg">
                                        <div className="dark-bg"></div>
                                        <img src="/oitid/student/assets/images/project/2021/id_exercise/scene_02.jpg" alt="" />
                                    </a>
                                    </div>
                                </div>
                                <div className={`col-12 col-sm-12 col-md-12 col-lg-15 col-xl-15 portfolio-box anim-bot`} >                            
                                    <div className="portfolio-image">
                                    <a href="/oitid/student/assets/images/project/2021/id_exercise/scene_03.jpg">
                                        <div className="dark-bg"></div>
                                        <img src="/oitid/student/assets/images/project/2021/id_exercise/scene_03.jpg" alt="" />
                                    </a>
                                    </div>
                                </div>
                                <div className={`col-12 col-sm-12 col-md-12 col-lg-15 col-xl-15 portfolio-box anim-bot`} >                            
                                    <div className="portfolio-image">
                                    <a href="/oitid/student/assets/images/project/2021/id_exercise/scene_04.jpg">
                                        <div className="dark-bg"></div>
                                        <img src="/oitid/student/assets/images/project/2021/id_exercise/scene_04.jpg" alt="" />
                                    </a>
                                    </div>
                                </div>
                                <div className={`col-12 col-sm-12 col-md-12 col-lg-15 col-xl-15 portfolio-box anim-bot`} >                            
                                    <div className="portfolio-image">
                                    <a href="/oitid/student/assets/images/project/2021/id_exercise/scene_05.jpg">
                                        <div className="dark-bg"></div>
                                        <img src="/oitid/student/assets/images/project/2021/id_exercise/scene_05.jpg" alt="" />
                                    </a>
                                    </div>
                                </div>
                                
                            </div>
                        </SRLWrapper>
                    </SimpleReactLightbox>
                    
                </div>

            </div>
        </section>
    )
}
export default Works



